'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('./core/index.js');



exports.default = index['default'];
